import React from "react";
import { object, number, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";

import { getSlug } from "../../utils";

import CardImageType1 from "../../molecules/card-image-type-1";
import ReadMore from "../../atoms/read-more";
import Headline from "../../atoms/headline";

import "./organism-5.m.css";

const Organism5 = ({ collection, headlineLimit, sections, widths = [250, 480, 764] }) => {
  const collectionStories = collection.items ? collection.items : [];
  const filteredStories = collectionStories.filter(item => item.type === "story");
  const slug = getSlug(collection, sections);

  return (
    <div>
      <div styleName="header-tabs">
        <Link href={slug}>
          <Headline text={collection.name} headerType={2} headerLevel={3} headlineLimit={headlineLimit} />
        </Link>
      </div>
      {filteredStories.length > 0 && (
        <CardImageType1 story={filteredStories[0].story} headlineLimit={headlineLimit} widths={widths} />
      )}
      {filteredStories.length > 1 && (
        <div styleName="read-more">
          <ReadMore href={slug} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

Organism5.propTypes = {
  collection: object,
  headlineLimit: number,
  sections: array,
  widths: array
};

export default connect(
  mapStateToProps,
  null
)(Organism5);
